/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No matching records found." |
*
* @param {Explorer_Search_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_no_results = /** @type {((inputs?: Explorer_Search_No_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_No_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "de") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "it") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No matching records found.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No matching records found.")
	return /** @type {LocalizedString} */ ("No matching records found.")
});